import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CompareToggleProps {
  value: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  disabledReason?: string;
}

export function CompareToggle({
  value,
  onChange,
  disabled = false,
  disabledReason,
}: CompareToggleProps) {
  const inner = (
    <div className="flex items-center gap-2">
      <Switch
        id="compare-toggle"
        checked={value}
        onCheckedChange={onChange}
        disabled={disabled}
        size="sm"
        aria-label="Compare with previous period"
      />
      <Label
        htmlFor="compare-toggle"
        className="text-sm select-none whitespace-nowrap cursor-pointer"
      >
        Compare
      </Label>
    </div>
  );

  if (disabled && disabledReason) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="opacity-50 cursor-not-allowed">{inner}</span>
          </TooltipTrigger>
          <TooltipContent>
            <p>{disabledReason}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return inner;
}
